import '../../../style/tips.scss'
import tipsIcon from '../../../static/images/tipicon.png'
export function createHeaderTips () {
  return {
    functional: true,
    render(h, context) {
      const { column, tipsOptions } = context.props
      const slots = context.slots().default || {}
      const rawName = 'kyeHeaderTipsPop' + column.key
      const INode = h('img', {
        class: 'tips-icon',
        attrs: {
          src: tipsIcon
        },
        on: {
          click: (event) => {
            event.stopPropagation()
          }
        },
        directives: [
          {
            name: 'popover',
            rawName: `v-popover:${rawName}`,
            value: '',
            arg: `${rawName}`,
            modifiers: undefined
          }
        ]
      })
      return <div class="virtual-header-tips">
        <el-popover
          ref='popover'
          {
            ...{
              props: {
                trigger: 'hover',
                ...tipsOptions
              },
              ref: rawName
            }
          }
        >
          {slots}
        </el-popover>
        {
          INode
        }
      </div>
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/tips/index.js